export default __webpack_public_path__ + "static/media/filter.b37261f1.svg";